import { render, staticRenderFns } from "./RightDictionaryTable.vue?vue&type=template&id=2e59caab&scoped=true"
import script from "./RightDictionaryTable.vue?vue&type=script&lang=js"
export * from "./RightDictionaryTable.vue?vue&type=script&lang=js"
import style0 from "./RightDictionaryTable.vue?vue&type=style&index=0&id=2e59caab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e59caab",
  null
  
)

export default component.exports